import {
  FilterMode,
  LlmProviderCreateMutationVariables,
  LlmProvider_OrderBy,
  LlmProvider,
  SortOrder,
  LlmProvider_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const llmProviderService = {
  createOne: buildCreateOne(
    (llmProviderCreateVariables: LlmProviderCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.llmProviderCreate(llmProviderCreateVariables);
        return result.llmProviderCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.llmProviderOne({ id });
    return result.llmProviderOne as LlmProvider;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: LlmProvider_OrderBy[] | null = null,
    filter: LlmProvider_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: LlmProvider_Filter | undefined;
    if (searchValue !== "") {
      where = {
        OR: [
          { name: { contains: searchValue, mode: FilterMode.Insensitive } },
          { code: { contains: searchValue, mode: FilterMode.Insensitive } },
        ],
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.llmProviderListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ name: SortOrder.Asc }, { code: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.llmProviderListWithOffset
    ) as LlmProvider[];
    return { list, orderBy };
  },
};
